<div class="p-2 w-100">
  
    <!-- Header minimalista -->
    <div class="uncp-header text-white p-4 mb-4">
        <div class="d-flex justify-content-between align-items-center">
        <div>
            <h3 class="mb-1 fw-light">
            <i class="fas fa-file-contract me-2"></i>
            Gestión de Contratos de Bienes y Servicios
            </h3>
        </div>
        <button class="btn btn-light uncp-btn" data-bs-toggle="modal" data-bs-target="#modalAdd">
            <i class="fas fa-plus me-1"></i>
            Nuevo Contrato
        </button>
        </div>
    </div>

    <!-- Estadísticas rápidas -->
    <div class="row mb-4">
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-file-contract text-primary fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Total</h6>
                                <span class="text-muted small">Contratos</span>
                            </div>
                        </div>
                        <span class="badge bg-primary fs-5 px-3 py-2">25</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-play-circle text-success fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">En Ejecución</h6>
                                <span class="text-muted small">Activos</span>
                            </div>
                        </div>
                        <span class="badge bg-success fs-5 px-3 py-2">18</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-check-circle text-info fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Completados</h6>
                                <span class="text-muted small">Finalizados</span>
                            </div>
                        </div>
                        <span class="badge bg-info fs-5 px-3 py-2">5</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card border-0 shadow-sm">
                <div class="card-body py-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <i class="fas fa-exclamation-triangle text-warning fs-4 me-3"></i>
                            <div>
                                <h6 class="mb-0 fw-bold">Por Vencer</h6>
                                <span class="text-muted small">30 días</span>
                            </div>
                        </div>
                        <span class="badge bg-warning fs-5 px-3 py-2">2</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Controles de búsqueda y filtros -->
    <div class="row mx-0 mb-3 align-items-center">
        <div class="col-md-4 px-1">
            <div class="input-group">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
                <input type="text" class="form-control" placeholder="Buscar por contrato o contratista...">
            </div>
        </div>
        <div class="col-md-2 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Todos los tipos</option>
                <option value="bienes">Bienes</option>
                <option value="servicios">Servicios</option>
                <option value="consultoria">Consultoría</option>
            </select>
        </div>
        <div class="col-md-2 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Todos los estados</option>
                <option value="ejecucion">En Ejecución</option>
                <option value="completado">Completado</option>
                <option value="por_vencer">Por Vencer</option>
                <option value="vencido">Vencido</option>
            </select>
        </div>
        <div class="col-md-2 px-1 mt-2 mt-md-0">
            <select class="form-select">
                <option value="">Año</option>
                <option value="2025">2025</option>
                <option value="2024">2024</option>
                <option value="2023">2023</option>
                <option value="2022">2022</option>
            </select>
        </div>
        <div class="col-md-2 px-1 text-md-end mt-2 mt-md-0">
            <div class="d-flex align-items-center justify-content-md-end">
                <span class="me-2 small text-muted">Mostrar:</span>
                <select class="form-select form-select-sm w-auto">
                    <option value="20">20</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                </select>
            </div>
        </div>
    </div>

    <!-- Tabla -->
    <div class="card uncp-card">
        <div class="table-responsive">
            <table class="table table-hover uncp-table mb-0">
                <thead>
                    <tr>
                        <th style="min-width: 15px;">#</th>
                        <th>Contrato</th>
                        <th class="d-none d-lg-table-cell">Contratista</th>
                        <th class="d-none d-md-table-cell">Monto</th>
                        <th>Periodo</th>
                        <th class="text-center">Estado</th>
                        <th class="text-center" style="width: 140px;">Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    <!-- Loading -->
                    <tr class="d-none">
                        <td colspan="7" class="text-center py-4">
                        <div class="spinner-border text-uncp" role="status"></div>
                        <div class="mt-2">Cargando...</div>
                        </td>
                    </tr>
                    <!-- Datos de ejemplo -->
                    <tr>
                        <td class="text-muted small">1</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-file-contract text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">CONTRATO N° 009-2022-LOGUNCP</div>
                                    <small class="text-muted">Servicio de Limpieza y Jardinería</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div>
                                <div class="fw-medium small">CONSORCIO PICHAY</div>
                                <small class="text-muted">RUC: 20593790613</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <div class="fw-medium text-success">S/ 4,250,100.00</div>
                            <small class="text-muted">24 meses</small>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>Inicio:</strong> 06/06/2022</div>
                                <div><strong>Fin:</strong> 05/11/2024</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-success">En Ejecución</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetalles">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-secondary" title="Adendas" data-bs-toggle="modal" data-bs-target="#modalAdendas">
                                    <i class="fas fa-plus-square"></i>
                                </button>
                                <button class="btn btn-outline-danger" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted small">2</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-file-contract text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">CONTRATO N° 012-2023-UNCP</div>
                                    <small class="text-muted">Suministro de Equipos de Cómputo</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div>
                                <div class="fw-medium small">TECH SOLUTIONS SAC</div>
                                <small class="text-muted">RUC: 20345678901</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <div class="fw-medium text-success">S/ 850,000.00</div>
                            <small class="text-muted">6 meses</small>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>Inicio:</strong> 15/01/2023</div>
                                <div><strong>Fin:</strong> 15/07/2023</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-info">Completado</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetalles">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-secondary" title="Adendas" data-bs-toggle="modal" data-bs-target="#modalAdendas">
                                    <i class="fas fa-plus-square"></i>
                                </button>
                                <button class="btn btn-outline-danger" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="text-muted small">3</td>
                        <td>
                            <div class="d-flex align-items-center">
                                <i class="fas fa-file-contract text-uncp me-2 fa-lg"></i>
                                <div>
                                    <div class="fw-medium">CONTRATO N° 018-2024-UNCP</div>
                                    <small class="text-muted">Consultoría en Infraestructura</small>
                                </div>
                            </div>
                        </td>
                        <td class="d-none d-lg-table-cell">
                            <div>
                                <div class="fw-medium small">CONSTRUCTORA CENTRAL EIRL</div>
                                <small class="text-muted">RUC: 20456789012</small>
                            </div>
                        </td>
                        <td class="d-none d-md-table-cell">
                            <div class="fw-medium text-success">S/ 1,200,000.00</div>
                            <small class="text-muted">12 meses</small>
                        </td>
                        <td>
                            <div class="small">
                                <div><strong>Inicio:</strong> 01/03/2024</div>
                                <div class="text-warning"><strong>Fin:</strong> 28/02/2025</div>
                            </div>
                        </td>
                        <td class="text-center">
                            <span class="badge bg-warning">Por Vencer</span>
                        </td>
                        <td class="text-center">
                            <div class="btn-group btn-group-sm">
                                <button class="btn btn-outline-primary" title="Editar" data-bs-toggle="modal" data-bs-target="#modalAdd">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-outline-info" title="Ver detalles" data-bs-toggle="modal" data-bs-target="#modalDetalles">
                                    <i class="fas fa-eye"></i>
                                </button>
                                <button class="btn btn-outline-secondary" title="Adendas" data-bs-toggle="modal" data-bs-target="#modalAdendas">
                                    <i class="fas fa-plus-square"></i>
                                </button>
                                <button class="btn btn-outline-danger" title="Eliminar" data-bs-toggle="modal" data-bs-target="#modalEliminar">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!-- Paginación -->
    <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="text-muted small">
            Mostrando 1 a 20 de 25 registros
        </div>
        <nav>
            <ul class="pagination pagination-sm mb-0">
                <li class="page-item disabled">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-angle-double-left"></i>
                </a>
                </li>
                <li class="page-item disabled">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-chevron-left"></i>
                </a>
                </li>
                <li class="page-item active">
                <a class="page-link" style="cursor:pointer;">1</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">2</a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-chevron-right"></i>
                </a>
                </li>
                <li class="page-item">
                <a class="page-link" style="cursor:pointer;">
                    <i class="fas fa-angle-double-right"></i>
                </a>
                </li>
            </ul>
        </nav>
    </div>

</div>

<!-- Modal Crear/Editar Contrato -->
<div class="modal fade" id="modalAdd" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                <i class="fas fa-file-contract me-2"></i>
                Nuevo Contrato de Bienes y Servicios
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            
            <form novalidate>
                <div class="modal-body p-4">
                    <div class="row">
                        <!-- DATOS DEL DOCUMENTO -->
                        <div class="col-12">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-file-alt me-2"></i>
                                1. DATOS DEL DOCUMENTO
                            </h6>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Número del documento <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="CP0292025" value="CP0292025">
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Fecha de emisión <span class="text-danger">*</span></label>
                            <input type="date" class="form-control" value="2025-02-03">
                        </div>
                        
                        <!-- DATOS DEL CONTRATISTA -->
                        <div class="col-12 mt-3">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-building me-2"></i>
                                2. DATOS DEL CONTRATISTA
                            </h6>
                        </div>
                        
                        <!-- Tipo de Contratista -->
                        <div class="col-12 mb-3">
                            <label class="form-label">Tipo de Contratista <span class="text-danger">*</span></label>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="tipoContratista" id="proveedor_unico" value="proveedor" checked>
                                <label class="form-check-label" for="proveedor_unico">
                                    <i class="fas fa-building me-1"></i> Proveedor Único
                                </label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" name="tipoContratista" id="consorcio" value="consorcio">
                                <label class="form-check-label" for="consorcio">
                                    <i class="fas fa-users me-1"></i> Consorcio
                                </label>
                            </div>
                        </div>
                        
                        <!-- Datos para Proveedor Único -->
                        <div id="datosProveedorUnico" class="proveedor-section">
                            <!-- Búsqueda por RUC -->
                            <div class="row">
                                <div class="col-12 mb-4">
                                    <div class="card border-primary">
                                        <div class="card-header bg-primary text-white py-2">
                                            <h6 class="mb-0">
                                                <i class="fas fa-search me-2"></i>
                                                Búsqueda de Proveedor
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row align-items-end">
                                                <div class="col-md-6 mb-2">
                                                    <label class="form-label">RUC del Proveedor <span class="text-danger">*</span></label>
                                                    <input type="text" id="rucProveedor" class="form-control" placeholder="20XXXXXXXXX" maxlength="11" oninput="buscarProveedor(this.value)">
                                                    <div class="form-text">Ingrese el RUC para buscar automáticamente</div>
                                                </div>
                                                <div class="col-md-4 mb-2">
                                                    <button type="button" class="btn btn-outline-primary" onclick="buscarProveedorManual()">
                                                        <i class="fas fa-search me-1"></i>
                                                        Buscar
                                                    </button>
                                                    <button type="button" class="btn btn-outline-secondary ms-2" onclick="limpiarProveedor()">
                                                        <i class="fas fa-times me-1"></i>
                                                        Limpiar
                                                    </button>
                                                </div>
                                                <div class="col-md-2 mb-2">
                                                    <div id="statusProveedor" class="text-center">
                                                        <i class="fas fa-question-circle text-muted fa-2x" title="Sin buscar"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Información del Proveedor (Solo Lectura) -->
                            <div id="infoProveedor" class="row" style="display: none;">
                                <div class="col-12 mb-3">
                                    <div class="card bg-light">
                                        <div class="card-header py-2">
                                            <h6 class="mb-0 text-uncp">
                                                <i class="fas fa-building me-2"></i>
                                                Información del Proveedor
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-8 mb-3">
                                                    <label class="form-label fw-medium">Razón Social</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="razonSocialProveedor">
                                                        CONSORCIO PICHAY
                                                    </div>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label class="form-label fw-medium">RUC</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="rucProveedorInfo">
                                                        20593790613
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label class="form-label fw-medium">Estado</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="estadoProveedor">
                                                        <span class="badge bg-success">ACTIVO</span>
                                                    </div>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label class="form-label fw-medium">Condición</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="condicionProveedor">
                                                        <span class="badge bg-info">HABIDO</span>
                                                    </div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label class="form-label fw-medium">Dirección Fiscal</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="direccionProveedor">
                                                        AV. REAL 123, EL TAMBO, HUANCAYO, JUNÍN
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Representante Legal -->
                                <div class="col-12 mb-3">
                                    <div class="card bg-light">
                                        <div class="card-header py-2">
                                            <h6 class="mb-0 text-uncp">
                                                <i class="fas fa-user-tie me-2"></i>
                                                Representante Legal
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-8 mb-3">
                                                    <label class="form-label fw-medium">Nombres y Apellidos</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="nombreRepresentante">
                                                        JUAN CARLOS PÉREZ LÓPEZ
                                                    </div>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label class="form-label fw-medium">DNI</label>
                                                    <div class="form-control-plaintext bg-white border rounded px-3 py-2" id="dniRepresentante">
                                                        12345678
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Datos para Consorcio -->
                        <div id="datosConsorcio" class="proveedor-section" style="display: none;">
                            <!-- Información Básica del Consorcio -->
                            <div class="row">
                                <div class="col-12 mb-4">
                                    <div class="card border-success">
                                        <div class="card-header bg-success text-white py-2">
                                            <h6 class="mb-0">
                                                <i class="fas fa-users me-2"></i>
                                                Información del Consorcio
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="row">
                                                <div class="col-md-8 mb-3">
                                                    <label class="form-label">Nombre del Consorcio <span class="text-danger">*</span></label>
                                                    <input type="text" class="form-control" placeholder="CONSORCIO PICHAY" value="CONSORCIO PICHAY">
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label class="form-label">Total de Empresas</label>
                                                    <div class="form-control-plaintext bg-light border rounded px-3 py-2" id="totalEmpresas">
                                                        <span class="badge bg-primary">2</span> empresas
                                                    </div>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label class="form-label">Descripción</label>
                                                    <div class="form-control-plaintext bg-light border rounded px-3 py-2">
                                                        Consorcio conformado por empresas especializadas en servicios de limpieza y jardinería
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Gestión de Empresas -->
                            <div class="row">
                                <div class="col-12">
                                    <div class="d-flex justify-content-between align-items-center mb-3">
                                        <h6 class="text-uncp mb-0">
                                            <i class="fas fa-building me-2"></i>
                                            Empresas del Consorcio
                                        </h6>
                                        <button type="button" class="btn btn-sm btn-outline-primary" onclick="agregarEmpresaConsorcio()">
                                            <i class="fas fa-plus me-1"></i> Agregar Empresa
                                        </button>
                                    </div>
                                    
                                    <div id="empresasConsorcio">
                                        <!-- Empresa 1 -->
                                        <div class="card mb-3 empresa-card">
                                            <div class="card-header py-2" style="background: linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%);">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex align-items-center">
                                                        <span class="badge bg-primary me-2">1</span>
                                                        <span class="fw-medium">Empresa Líder</span>
                                                        <i class="fas fa-crown text-warning ms-2" title="Empresa Líder"></i>
                                                    </div>
                                                    <button type="button" class="btn btn-sm btn-outline-danger" onclick="eliminarEmpresaConsorcio(this)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <!-- Búsqueda por RUC -->
                                                <div class="row mb-3">
                                                    <div class="col-md-8">
                                                        <label class="form-label small fw-medium">RUC de la Empresa <span class="text-danger">*</span></label>
                                                        <div class="input-group input-group-sm">
                                                            <input type="text" class="form-control" placeholder="20XXXXXXXXX" maxlength="11" value="20593790613" oninput="buscarEmpresaConsorcio(this)">
                                                            <button class="btn btn-outline-primary" type="button" onclick="buscarEmpresaConsorcioManual(this)">
                                                                <i class="fas fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label class="form-label small fw-medium">Participación %</label>
                                                        <input type="number" class="form-control form-control-sm" placeholder="50" min="0" max="100" value="60">
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label class="form-label small fw-medium">Estado</label>
                                                        <div class="text-center mt-1">
                                                            <i class="fas fa-check-circle text-success fa-lg" title="Encontrada"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <!-- Información de la Empresa (Solo Lectura) -->
                                                <div class="empresa-info">
                                                    <div class="row">
                                                        <div class="col-md-12 mb-2">
                                                            <label class="form-label small fw-medium">Razón Social</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                CORPORACIÓN POSTAL SERVICIO S.A.C.
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="form-label small fw-medium">Estado SUNAT</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                <span class="badge bg-success">ACTIVO</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="form-label small fw-medium">Condición</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                <span class="badge bg-info">HABIDO</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-8 mb-2">
                                                            <label class="form-label small fw-medium">Representante Legal</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                CARLOS MARTINEZ RODRIGUEZ
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 mb-2">
                                                            <label class="form-label small fw-medium">DNI</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                43216789
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Empresa 2 -->
                                        <div class="card mb-3 empresa-card">
                                            <div class="card-header bg-light py-2">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div class="d-flex align-items-center">
                                                        <span class="badge bg-secondary me-2">2</span>
                                                        <span class="fw-medium">Empresa Asociada</span>
                                                    </div>
                                                    <button type="button" class="btn btn-sm btn-outline-danger" onclick="eliminarEmpresaConsorcio(this)">
                                                        <i class="fas fa-trash"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div class="card-body">
                                                <!-- Búsqueda por RUC -->
                                                <div class="row mb-3">
                                                    <div class="col-md-8">
                                                        <label class="form-label small fw-medium">RUC de la Empresa <span class="text-danger">*</span></label>
                                                        <div class="input-group input-group-sm">
                                                            <input type="text" class="form-control" placeholder="20XXXXXXXXX" maxlength="11" value="20600151763" oninput="buscarEmpresaConsorcio(this)">
                                                            <button class="btn btn-outline-primary" type="button" onclick="buscarEmpresaConsorcioManual(this)">
                                                                <i class="fas fa-search"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label class="form-label small fw-medium">Participación %</label>
                                                        <input type="number" class="form-control form-control-sm" placeholder="50" min="0" max="100" value="40">
                                                    </div>
                                                    <div class="col-md-2">
                                                        <label class="form-label small fw-medium">Estado</label>
                                                        <div class="text-center mt-1">
                                                            <i class="fas fa-check-circle text-success fa-lg" title="Encontrada"></i>
                                                        </div>
                                                    </div>
                                                </div>
                                                
                                                <!-- Información de la Empresa (Solo Lectura) -->
                                                <div class="empresa-info">
                                                    <div class="row">
                                                        <div class="col-md-12 mb-2">
                                                            <label class="form-label small fw-medium">Razón Social</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                IM CLEANING SERVICE S.A.C.
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="form-label small fw-medium">Estado SUNAT</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                <span class="badge bg-success">ACTIVO</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <label class="form-label small fw-medium">Condición</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                <span class="badge bg-info">HABIDO</span>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-8 mb-2">
                                                            <label class="form-label small fw-medium">Representante Legal</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                MARIA FERNANDEZ LOPEZ
                                                            </div>
                                                        </div>
                                                        <div class="col-md-4 mb-2">
                                                            <label class="form-label small fw-medium">DNI</label>
                                                            <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                                                                87654321
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Resumen del Consorcio -->
                                    <div class="alert alert-info mt-3">
                                        <div class="row">
                                            <div class="col-md-8">
                                                <i class="fas fa-info-circle me-2"></i>
                                                <strong>Resumen:</strong> Total de participaciones: <span id="totalParticipacion" class="fw-bold text-success">100%</span>
                                            </div>
                                            <div class="col-md-4 text-end">
                                                <span class="badge bg-warning">
                                                    <i class="fas fa-crown me-1"></i>
                                                    Líder: Empresa 1
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- DATOS DEL CONTRATO -->
                        <div class="col-12 mt-3">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-handshake me-2"></i>
                                3. DATOS DEL CONTRATO
                            </h6>
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Número del contrato <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="CONTRATO N° 009-2022-LOGUNCP">
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Tipo y número del procedimiento <span class="text-danger">*</span></label>
                            <input type="text" class="form-control" placeholder="CONCURSO PUBLICO N° 002-2022-COSEP-UNCP-1">
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Modalidad de Contrato</label>
                            <select class="form-select">
                                <option value="">Seleccionar...</option>
                                <option value="suma_alzada" selected>SUMA ALZADA</option>
                                <option value="precios_unitarios">PRECIOS UNITARIOS</option>
                                <option value="administracion_directa">ADMINISTRACIÓN DIRECTA</option>
                            </select>
                        </div>
                        
                        <div class="col-12 mb-3">
                            <label class="form-label">Descripción del objeto del contrato <span class="text-danger">*</span></label>
                            <textarea class="form-control" rows="2" placeholder="CONTRATACION DEL SERVICIO DE LIMPIEZA Y JARDINERIA PARA LA UNCP"></textarea>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Fecha de suscripción <span class="text-danger">*</span></label>
                            <input type="date" class="form-control" value="2022-06-02">
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Plazo de ejecución</label>
                            <input type="text" class="form-control" placeholder="24 meses">
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Monto del contrato <span class="text-danger">*</span></label>
                            <input type="number" class="form-control" placeholder="4250100.00" step="0.01">
                        </div>
                        
                        <!-- DATOS DEL SERVICIO -->
                        <div class="col-12 mt-3">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-cogs me-2"></i>
                                4. DATOS DEL SERVICIO
                            </h6>
                        </div>
                        
                        <div class="col-12 mb-3">
                            <label class="form-label">Denominación del servicio <span class="text-danger">*</span></label>
                            <textarea class="form-control" rows="2" placeholder="CONTRATACION DE SERVICIO DE LIMPIEZA Y JARDINERIA PARA LA UNCP"></textarea>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Inicio del Servicio</label>
                            <input type="date" class="form-control" value="2022-06-06">
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Término del Servicio</label>
                            <input type="date" class="form-control" value="2024-11-05">
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">Total de plazo de ejecución</label>
                            <input type="text" class="form-control" placeholder="29 meses">
                        </div>
                        

                        
                        <!-- APLICACIÓN DE PENALIDADES -->
                        <div class="col-12 mt-3">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-exclamation-triangle me-2"></i>
                                5. APLICACIÓN DE PENALIDADES
                            </h6>
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="penalidades" id="penalidades_si" value="SI">
                                <label class="form-check-label" for="penalidades_si">SÍ</label>
                            </div>
                            <div class="form-check">
                                <input class="form-check-input" type="radio" name="penalidades" id="penalidades_no" value="NO" checked>
                                <label class="form-check-label" for="penalidades_no">NO</label>
                            </div>
                        </div>
                        
                        <div class="col-md-6 mb-3">
                            <label class="form-label">Monto de la penalidad S/</label>
                            <input type="number" class="form-control" placeholder="51,077.52" step="0.01">
                        </div>
                        
                        <!-- DATOS DE LA ENTIDAD -->
                        <div class="col-12 mt-3">
                            <h6 class="text-uncp mb-3 pb-2 border-bottom">
                                <i class="fas fa-university me-2"></i>
                                6. DATOS DE LA ENTIDAD
                            </h6>
                        </div>
                        
                        <div class="col-md-8 mb-3">
                            <label class="form-label">Nombre de la Entidad</label>
                            <input type="text" class="form-control" value="UNIVERSIDAD NACIONAL DEL CENTRO DEL PERÚ" readonly>
                        </div>
                        
                        <div class="col-md-4 mb-3">
                            <label class="form-label">RUC de la Entidad</label>
                            <input type="text" class="form-control" value="20145561095" readonly>
                        </div>
                        
                        <div class="col-12 mb-3">
                            <label class="form-label">Nombres y apellidos del funcionario que emite la constancia</label>
                            <input type="text" class="form-control" placeholder="LIC. MIGUEL ANGEL HURTADO SANCHEZ">
                        </div>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        Cancelar
                    </button>
                    <button type="submit" class="btn btn-primary">
                        <i class="fas fa-save me-1"></i>
                        Guardar Contrato
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<script>
// Funciones para manejar el modal de contratos
document.addEventListener('DOMContentLoaded', function() {
    // Manejar cambio entre proveedor único y consorcio
    const radioProveedor = document.getElementById('proveedor_unico');
    const radioConsorcio = document.getElementById('consorcio');
    const datosProveedorUnico = document.getElementById('datosProveedorUnico');
    const datosConsorcio = document.getElementById('datosConsorcio');
    
    if (radioProveedor && radioConsorcio) {
        radioProveedor.addEventListener('change', function() {
            if (this.checked) {
                datosProveedorUnico.style.display = 'block';
                datosConsorcio.style.display = 'none';
            }
        });
        
        radioConsorcio.addEventListener('change', function() {
            if (this.checked) {
                datosProveedorUnico.style.display = 'none';
                datosConsorcio.style.display = 'block';
            }
        });
    }
});

// === FUNCIONES PARA PROVEEDOR ÚNICO ===

// Función para buscar proveedor por RUC (automática)
function buscarProveedor(ruc) {
    if (ruc.length === 11) {
        buscarProveedorManual();
    }
}

// Función para buscar proveedor manualmente
function buscarProveedorManual() {
    const rucInput = document.getElementById('rucProveedor');
    const statusIcon = document.getElementById('statusProveedor');
    const infoProveedor = document.getElementById('infoProveedor');
    
    const ruc = rucInput.value.trim();
    
    if (ruc.length !== 11) {
        alert('El RUC debe tener 11 dígitos');
        return;
    }
    
    // Mostrar estado de búsqueda
    statusIcon.innerHTML = '<i class="fas fa-spinner fa-spin text-primary fa-2x" title="Buscando..."></i>';
    
    // Simular búsqueda (aquí iría la llamada al API)
    setTimeout(() => {
        if (ruc === '20593790613') {
            // Proveedor encontrado
            statusIcon.innerHTML = '<i class="fas fa-check-circle text-success fa-2x" title="Encontrado"></i>';
            
            // Llenar datos del proveedor
            document.getElementById('razonSocialProveedor').textContent = 'CONSORCIO PICHAY';
            document.getElementById('rucProveedorInfo').textContent = '20593790613';
            document.getElementById('estadoProveedor').innerHTML = '<span class="badge bg-success">ACTIVO</span>';
            document.getElementById('condicionProveedor').innerHTML = '<span class="badge bg-info">HABIDO</span>';
            document.getElementById('direccionProveedor').textContent = 'AV. REAL 123, EL TAMBO, HUANCAYO, JUNÍN';
            document.getElementById('nombreRepresentante').textContent = 'JUAN CARLOS PÉREZ LÓPEZ';
            document.getElementById('dniRepresentante').textContent = '12345678';
            
            // Mostrar información
            infoProveedor.style.display = 'block';
        } else {
            // Proveedor no encontrado
            statusIcon.innerHTML = '<i class="fas fa-times-circle text-danger fa-2x" title="No encontrado"></i>';
            infoProveedor.style.display = 'none';
            alert('Proveedor no encontrado en el registro SUNAT');
        }
    }, 1500);
}

// Función para limpiar datos del proveedor
function limpiarProveedor() {
    document.getElementById('rucProveedor').value = '';
    document.getElementById('statusProveedor').innerHTML = '<i class="fas fa-question-circle text-muted fa-2x" title="Sin buscar"></i>';
    document.getElementById('infoProveedor').style.display = 'none';
}

// === FUNCIONES PARA CONSORCIO ===

// Función para buscar empresa en consorcio
function buscarEmpresaConsorcio(input) {
    const ruc = input.value.trim();
    if (ruc.length === 11) {
        buscarEmpresaConsorcioManual(input);
    }
}

// Función para buscar empresa manualmente
function buscarEmpresaConsorcioManual(button) {
    const card = button.closest('.empresa-card');
    const rucInput = card.querySelector('input[maxlength="11"]');
    const statusIcon = card.querySelector('.col-md-2 .text-center');
    const empresaInfo = card.querySelector('.empresa-info');
    
    const ruc = rucInput.value.trim();
    
    if (ruc.length !== 11) {
        alert('El RUC debe tener 11 dígitos');
        return;
    }
    
    // Mostrar estado de búsqueda
    statusIcon.innerHTML = '<i class="fas fa-spinner fa-spin text-primary fa-lg" title="Buscando..."></i>';
    
    // Simular búsqueda
    setTimeout(() => {
        const empresasData = {
            '20593790613': {
                razonSocial: 'CORPORACIÓN POSTAL SERVICIO S.A.C.',
                estado: 'ACTIVO',
                condicion: 'HABIDO',
                representante: 'CARLOS MARTINEZ RODRIGUEZ',
                dni: '43216789'
            },
            '20600151763': {
                razonSocial: 'IM CLEANING SERVICE S.A.C.',
                estado: 'ACTIVO',
                condicion: 'HABIDO',
                representante: 'MARIA FERNANDEZ LOPEZ',
                dni: '87654321'
            }
        };
        
        if (empresasData[ruc]) {
            const data = empresasData[ruc];
            
            // Empresa encontrada
            statusIcon.innerHTML = '<i class="fas fa-check-circle text-success fa-lg" title="Encontrada"></i>';
            
            // Llenar datos
            const razonSocialDiv = empresaInfo.querySelector('.col-md-12 .form-control-plaintext');
            const estadoDiv = empresaInfo.querySelector('.col-md-6:nth-child(2) .form-control-plaintext');
            const condicionDiv = empresaInfo.querySelector('.col-md-6:nth-child(3) .form-control-plaintext');
            const representanteDiv = empresaInfo.querySelector('.col-md-8 .form-control-plaintext');
            const dniDiv = empresaInfo.querySelector('.col-md-4 .form-control-plaintext');
            
            razonSocialDiv.textContent = data.razonSocial;
            estadoDiv.innerHTML = `<span class="badge bg-success">${data.estado}</span>`;
            condicionDiv.innerHTML = `<span class="badge bg-info">${data.condicion}</span>`;
            representanteDiv.textContent = data.representante;
            dniDiv.textContent = data.dni;
            
            // Mostrar información
            empresaInfo.style.display = 'block';
        } else {
            // Empresa no encontrada
            statusIcon.innerHTML = '<i class="fas fa-times-circle text-danger fa-lg" title="No encontrada"></i>';
            empresaInfo.style.display = 'none';
            alert('Empresa no encontrada en el registro SUNAT');
        }
    }, 1000);
}

// Función para agregar nueva empresa al consorcio
function agregarEmpresaConsorcio() {
    const container = document.getElementById('empresasConsorcio');
    const empresas = container.querySelectorAll('.empresa-card');
    const numeroEmpresa = empresas.length + 1;
    
    const nuevaEmpresa = document.createElement('div');
    nuevaEmpresa.className = 'card mb-3 empresa-card';
    nuevaEmpresa.innerHTML = `
        <div class="card-header bg-light py-2">
            <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                    <span class="badge bg-secondary me-2">${numeroEmpresa}</span>
                    <span class="fw-medium">Empresa Asociada</span>
                </div>
                <button type="button" class="btn btn-sm btn-outline-danger" onclick="eliminarEmpresaConsorcio(this)">
                    <i class="fas fa-trash"></i>
                </button>
            </div>
        </div>
        <div class="card-body">
            <!-- Búsqueda por RUC -->
            <div class="row mb-3">
                <div class="col-md-8">
                    <label class="form-label small fw-medium">RUC de la Empresa <span class="text-danger">*</span></label>
                    <div class="input-group input-group-sm">
                        <input type="text" class="form-control" placeholder="20XXXXXXXXX" maxlength="11" oninput="buscarEmpresaConsorcio(this)">
                        <button class="btn btn-outline-primary" type="button" onclick="buscarEmpresaConsorcioManual(this)">
                            <i class="fas fa-search"></i>
                        </button>
                    </div>
                </div>
                <div class="col-md-2">
                    <label class="form-label small fw-medium">Participación %</label>
                    <input type="number" class="form-control form-control-sm" placeholder="0" min="0" max="100">
                </div>
                <div class="col-md-2">
                    <label class="form-label small fw-medium">Estado</label>
                    <div class="text-center mt-1">
                        <i class="fas fa-question-circle text-muted fa-lg" title="Sin buscar"></i>
                    </div>
                </div>
            </div>
            
            <!-- Información de la Empresa (Solo Lectura) -->
            <div class="empresa-info" style="display: none;">
                <div class="row">
                    <div class="col-md-12 mb-2">
                        <label class="form-label small fw-medium">Razón Social</label>
                        <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                            
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <label class="form-label small fw-medium">Estado SUNAT</label>
                        <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                            
                        </div>
                    </div>
                    <div class="col-md-6 mb-2">
                        <label class="form-label small fw-medium">Condición</label>
                        <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                            
                        </div>
                    </div>
                    <div class="col-md-8 mb-2">
                        <label class="form-label small fw-medium">Representante Legal</label>
                        <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                            
                        </div>
                    </div>
                    <div class="col-md-4 mb-2">
                        <label class="form-label small fw-medium">DNI</label>
                        <div class="form-control-plaintext form-control-sm bg-white border rounded px-2 py-1">
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    container.appendChild(nuevaEmpresa);
    actualizarTotalEmpresas();
}

// Función para eliminar empresa del consorcio
function eliminarEmpresaConsorcio(button) {
    const empresaCard = button.closest('.empresa-card');
    const container = document.getElementById('empresasConsorcio');
    const empresas = container.querySelectorAll('.empresa-card');
    
    // No permitir eliminar si solo hay una empresa
    if (empresas.length <= 1) {
        alert('Debe tener al menos una empresa en el consorcio.');
        return;
    }
    
    empresaCard.remove();
    renumerarEmpresas();
    actualizarTotalEmpresas();
}

// Función para renumerar empresas
function renumerarEmpresas() {
    const container = document.getElementById('empresasConsorcio');
    const empresas = container.querySelectorAll('.empresa-card');
    
    empresas.forEach((empresa, index) => {
        const badge = empresa.querySelector('.badge');
        const titulo = empresa.querySelector('.fw-medium');
        
        badge.textContent = index + 1;
        titulo.textContent = index === 0 ? 'Empresa Líder' : 'Empresa Asociada';
        
        // Actualizar header de la primera empresa
        if (index === 0) {
            const header = empresa.querySelector('.card-header');
            header.style.background = 'linear-gradient(135deg, #e3f2fd 0%, #f3e5f5 100%)';
            titulo.innerHTML = 'Empresa Líder <i class="fas fa-crown text-warning ms-2" title="Empresa Líder"></i>';
        } else {
            const header = empresa.querySelector('.card-header');
            header.className = 'card-header bg-light py-2';
        }
    });
}

// Función para actualizar total de empresas
function actualizarTotalEmpresas() {
    const container = document.getElementById('empresasConsorcio');
    const totalEmpresas = container.querySelectorAll('.empresa-card').length;
    const totalEmpresasDiv = document.getElementById('totalEmpresas');
    
    if (totalEmpresasDiv) {
        totalEmpresasDiv.innerHTML = `<span class="badge bg-primary">${totalEmpresas}</span> empresas`;
    }
}
</script>

<!-- Modal Ver Detalles -->
<div class="modal fade" id="modalDetalles" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-info text-white">
                <h5 class="modal-title">
                <i class="fas fa-eye me-2"></i>
                Detalles del Contrato
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body p-4">
                <div class="row">
                    <!-- Información principal -->
                    <div class="col-md-8">
                        <h4 class="text-uncp mb-1">CONTRATO N° 009-2022-LOGUNCP</h4>
                        <p class="text-muted mb-3">Servicio de Limpieza y Jardinería para la UNCP</p>
                        
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Contratista:</strong></div>
                            <div class="col-sm-8">CONSORCIO PICHAY</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>RUC:</strong></div>
                            <div class="col-sm-8">20593790613</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Monto:</strong></div>
                            <div class="col-sm-8 text-success fw-bold">S/ 4,250,100.00</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Modalidad:</strong></div>
                            <div class="col-sm-8">SUMA ALZADA</div>
                        </div>
                        <div class="row mb-3">
                            <div class="col-sm-4"><strong>Fecha Suscripción:</strong></div>
                            <div class="col-sm-8">02/06/2022</div>
                        </div>
                    </div>
                    
                    <!-- Estado y progreso -->
                    <div class="col-md-4">
                        <div class="card bg-light">
                            <div class="card-body text-center">
                                <i class="fas fa-play-circle text-success fa-3x mb-2"></i>
                                <h5 class="text-success">EN EJECUCIÓN</h5>
                                <small class="text-muted">Estado actual</small>
                            </div>
                        </div>
                        
                        <div class="mt-3">
                            <h6 class="text-uncp">Progreso</h6>
                            <div class="progress mb-2">
                                <div class="progress-bar bg-success" style="width: 75%"></div>
                            </div>
                            <small class="text-muted">75% completado</small>
                        </div>
                        
                        <div class="mt-3">
                            <h6 class="text-uncp">Fechas Importantes</h6>
                            <div class="d-flex justify-content-between mb-2">
                                <span class="small">Inicio:</span>
                                <span class="badge bg-primary small">06/06/2022</span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <span class="small">Fin:</span>
                                <span class="badge bg-warning small">05/11/2024</span>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Descripción -->
                    <div class="col-12 mt-4">
                        <h6 class="text-uncp">
                            <i class="fas fa-file-alt me-2"></i>
                            Descripción del Servicio
                        </h6>
                        <p class="text-muted">CONTRATACION DEL SERVICIO DE LIMPIEZA Y JARDINERIA PARA LA UNCP</p>
                    </div>
                    
                    <!-- Adendas -->
                    <div class="col-12 mt-3">
                        <h6 class="text-uncp">
                            <i class="fas fa-plus-square me-2"></i>
                            Adendas Aplicadas
                        </h6>
                        <div class="table-responsive">
                            <table class="table table-sm table-hover">
                                <thead class="table-light">
                                    <tr>
                                        <th>Adenda</th>
                                        <th>Descripción</th>
                                        <th>Monto</th>
                                        <th>Fecha</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><span class="badge bg-secondary">N° 001</span></td>
                                        <td>Modificación del plazo de ejecución</td>
                                        <td class="text-success">S/ 175,095.36</td>
                                        <td>15/03/2023</td>
                                    </tr>
                                    <tr>
                                        <td><span class="badge bg-secondary">N° 006</span></td>
                                        <td>Ampliación de plazo por 04 meses</td>
                                        <td class="text-success">S/ 737,699.08</td>
                                        <td>10/08/2023</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    
                    <!-- Penalidades -->
                    <div class="col-12 mt-3">
                        <h6 class="text-uncp">
                            <i class="fas fa-exclamation-triangle me-2"></i>
                            Penalidades
                        </h6>
                        <div class="alert alert-success">
                            <i class="fas fa-check-circle me-2"></i>
                            No se han aplicado penalidades a este contrato
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#modalAdd">
                    <i class="fas fa-edit me-1"></i>
                    Editar
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Eliminar -->
<div class="modal fade" id="modalEliminar" data-bs-backdrop="static" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header bg-danger text-white">
                <h6 class="modal-title">
                <i class="fas fa-trash me-2"></i>
                Confirmar Eliminación
                </h6>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            <div class="modal-body">
                <div class="text-center">
                <i class="fas fa-exclamation-triangle text-warning fa-2x mb-3"></i>
                <p>¿Eliminar el contrato <strong>CONTRATO N° 009-2022-LOGUNCP</strong>?</p>
                <small class="text-muted">Esta acción no se puede deshacer.</small>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                Cancelar
                </button>
                <button type="button" class="btn btn-danger">
                <i class="fas fa-trash me-1"></i>
                Eliminar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Modal Gestión de Adendas -->
<div class="modal fade" id="modalAdendas" tabindex="-1" data-bs-backdrop="static">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header bg-uncp text-white">
                <h5 class="modal-title">
                <i class="fas fa-plus-square me-2"></i>
                Gestión de Adendas - CONTRATO N° 009-2022-LOGUNCP
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
            </div>
            
            <div class="modal-body p-4">
                <div class="row">
                    <!-- Información del Contrato -->
                    <div class="col-12 mb-4">
                        <div class="card bg-light">
                            <div class="card-body py-3">
                                <div class="row">
                                    <div class="col-md-8">
                                        <h6 class="mb-1 fw-bold">CONTRATO N° 009-2022-LOGUNCP</h6>
                                        <p class="mb-0 text-muted">Servicio de Limpieza y Jardinería - CONSORCIO PICHAY</p>
                                    </div>
                                    <div class="col-md-4 text-md-end">
                                        <div class="fw-bold text-success">Monto Original: S/ 4,250,100.00</div>
                                        <div class="text-muted small">Total Adendas: S/ 912,794.44</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Botón Agregar Nueva Adenda -->
                    <div class="col-12 mb-3">
                        <button type="button" class="btn btn-primary" data-bs-toggle="collapse" data-bs-target="#formNuevaAdenda">
                            <i class="fas fa-plus me-1"></i>
                            Nueva Adenda
                        </button>
                    </div>
                    
                    <!-- Formulario Nueva Adenda (Colapsable) -->
                    <div class="col-12">
                        <div class="collapse" id="formNuevaAdenda">
                            <div class="card border-primary mb-4">
                                <div class="card-header bg-primary text-white">
                                    <h6 class="mb-0">
                                        <i class="fas fa-plus-circle me-2"></i>
                                        Registrar Nueva Adenda
                                    </h6>
                                </div>
                                <div class="card-body">
                                    <form>
                                        <div class="row">
                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Número de Adenda <span class="text-danger">*</span></label>
                                                <input type="text" class="form-control" placeholder="N° 009" required>
                                            </div>
                                            
                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Fecha de Adenda <span class="text-danger">*</span></label>
                                                <input type="date" class="form-control" required>
                                            </div>
                                            
                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Tipo de Adenda <span class="text-danger">*</span></label>
                                                <select class="form-select" required>
                                                    <option value="">Seleccionar...</option>
                                                    <option value="plazo">Modificación de plazo</option>
                                                    <option value="monto">Incremento de monto</option>
                                                    <option value="alcance">Cambio de alcance</option>
                                                    <option value="representante">Cambio de representante</option>
                                                    <option value="garantia">Ampliación de garantía</option>
                                                    <option value="otro">Otro</option>
                                                </select>
                                            </div>
                                            
                                            <div class="col-md-3 mb-3">
                                                <label class="form-label">Monto de Adenda S/</label>
                                                <input type="number" class="form-control" placeholder="0.00" step="0.01">
                                            </div>
                                            
                                            <div class="col-12 mb-3">
                                                <label class="form-label">Descripción/Motivo <span class="text-danger">*</span></label>
                                                <textarea class="form-control" rows="3" placeholder="Describa detalladamente el motivo y alcance de la adenda" required></textarea>
                                            </div>
                                            
                                            <div class="col-md-6 mb-3">
                                                <label class="form-label">Nueva Fecha de Término (si aplica)</label>
                                                <input type="date" class="form-control">
                                            </div>
                                            
                                            <div class="col-md-6 mb-3">
                                                <label class="form-label">Resolución que aprueba</label>
                                                <input type="text" class="form-control" placeholder="N° de Resolución">
                                            </div>
                                            
                                            <div class="col-12 mb-3">
                                                <label class="form-label">Observaciones adicionales</label>
                                                <textarea class="form-control" rows="2" placeholder="Observaciones adicionales (opcional)"></textarea>
                                            </div>
                                        </div>
                                        
                                        <div class="d-flex justify-content-end gap-2">
                                            <button type="button" class="btn btn-secondary" data-bs-toggle="collapse" data-bs-target="#formNuevaAdenda">
                                                Cancelar
                                            </button>
                                            <button type="submit" class="btn btn-primary">
                                                <i class="fas fa-save me-1"></i>
                                                Guardar Adenda
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- Lista de Adendas Existentes -->
                    <div class="col-12">
                        <h6 class="text-uncp mb-3">
                            <i class="fas fa-list me-2"></i>
                            Adendas Registradas
                        </h6>
                        
                        <div class="table-responsive">
                            <table class="table table-hover uncp-table">
                                <thead>
                                    <tr>
                                        <th style="width: 80px;">Adenda</th>
                                        <th>Descripción</th>
                                        <th style="width: 120px;">Tipo</th>
                                        <th style="width: 120px;">Monto</th>
                                        <th style="width: 110px;">Fecha</th>
                                        <th style="width: 100px;" class="text-center">Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <span class="badge bg-secondary fs-6">N° 001</span>
                                        </td>
                                        <td>
                                            <div>
                                                <div class="fw-medium">Modificación del plazo de ejecución</div>
                                                <small class="text-muted">Las Partes acuerdan la ampliación de la garantía el cual corresponde al 10% del incremento del contrato</small>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="badge bg-info">Plazo</span>
                                        </td>
                                        <td>
                                            <div class="fw-medium text-success">S/ 175,095.36</div>
                                        </td>
                                        <td>
                                            <div class="small">15/03/2023</div>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-outline-primary" title="Editar">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" title="Eliminar">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="badge bg-secondary fs-6">N° 002</span>
                                        </td>
                                        <td>
                                            <div>
                                                <div class="fw-medium">Ampliación conforme con la Resolución N° 1366-R-2022</div>
                                                <small class="text-muted">Cambio de representante común</small>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="badge bg-warning">Representante</span>
                                        </td>
                                        <td>
                                            <div class="fw-medium text-muted">S/ 0.00</div>
                                        </td>
                                        <td>
                                            <div class="small">22/05/2023</div>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-outline-primary" title="Editar">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" title="Eliminar">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="badge bg-secondary fs-6">N° 003</span>
                                        </td>
                                        <td>
                                            <div>
                                                <div class="fw-medium">Modificar la cláusula duodécima, penalidades</div>
                                                <small class="text-muted">Ajuste en penalidades según normativa vigente</small>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="badge bg-secondary">Alcance</span>
                                        </td>
                                        <td>
                                            <div class="fw-medium text-muted">S/ 0.00</div>
                                        </td>
                                        <td>
                                            <div class="small">10/08/2023</div>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-outline-primary" title="Editar">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" title="Eliminar">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="badge bg-secondary fs-6">N° 006</span>
                                        </td>
                                        <td>
                                            <div>
                                                <div class="fw-medium">Ampliación de plazo por 04 meses</div>
                                                <small class="text-muted">Del 06 de junio al 05 de octubre 2024</small>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="badge bg-info">Plazo</span>
                                        </td>
                                        <td>
                                            <div class="fw-medium text-success">S/ 737,699.08</div>
                                        </td>
                                        <td>
                                            <div class="small">15/06/2024</div>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-outline-primary" title="Editar">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" title="Eliminar">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <span class="badge bg-secondary fs-6">N° 007</span>
                                        </td>
                                        <td>
                                            <div>
                                                <div class="fw-medium">Ampliación de plazo por 01 mes</div>
                                                <small class="text-muted">Del 06 de octubre al 05 de noviembre 2024</small>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="badge bg-info">Plazo</span>
                                        </td>
                                        <td>
                                            <div class="fw-medium text-muted">S/ 0.00</div>
                                        </td>
                                        <td>
                                            <div class="small">01/10/2024</div>
                                        </td>
                                        <td class="text-center">
                                            <div class="btn-group btn-group-sm">
                                                <button class="btn btn-outline-primary" title="Editar">
                                                    <i class="fas fa-edit"></i>
                                                </button>
                                                <button class="btn btn-outline-danger" title="Eliminar">
                                                    <i class="fas fa-trash"></i>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        
                        <!-- Resumen de Adendas -->
                        <div class="row mt-4">
                            <div class="col-md-8">
                                <div class="alert alert-info">
                                    <i class="fas fa-info-circle me-2"></i>
                                    <strong>Total de Adendas:</strong> 5 registradas
                                </div>
                            </div>
                            <div class="col-md-4 text-end">
                                <div class="card bg-light">
                                    <div class="card-body py-2">
                                        <div class="fw-bold text-uncp">Monto Total con Adendas</div>
                                        <div class="h5 text-success mb-0">S/ 5,162,894.44</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-primary">
                    <i class="fas fa-file-export me-1"></i>
                    Exportar Adendas
                </button>
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>
